module.exports = __webpack_public_path__ + "static/assets/0208b3c5b09d0cfd77fdac8c99759639.png";